/**
 * Terminalin internetsizken kabul ettiği azami CRL (iptal listesi) yaşı.
 *
 * Serbest sayı yerine hazır seçenekler sunuluyor: bu iki yönde de yanlış
 * ayarlanabilen bir güvenlik parametresi — çok kısa değer internet kesintisinde
 * kapıyı tamamen kapatır, çok uzun değer iptal edilmiş bir kartın günlerce
 * geçerli kalmasına izin verir.
 *
 * Aralık üç yerde aynı olmalı:
 *   firmware  components/kr_net/update_setup.c  KR_CRL_AGE_MIN/MAX_HOURS (1..720)
 *   backend   src/services/terminalService.ts   MIN/MAX_CRL_AGE_HOURS
 *   burası    aşağıdaki seçenekler
 *
 * Hem "Yeni Tablet Kaydı" hem "Tablet Düzenle" bu listeyi kullanır — iki ekranın
 * seçenekleri ayrışmasın diye tek kaynak.
 */
export const CRL_AGE_OPTIONS = [
  { value: "24", label: "24 saat — sıkı" },
  { value: "48", label: "48 saat — varsayılan" },
  { value: "72", label: "72 saat" },
  { value: "168", label: "168 saat (1 hafta) — gevşek" },
];

export const DEFAULT_CRL_AGE_HOURS = 48;

export const CRL_AGE_DESCRIPTION =
  "Terminal internetsizken, iptal listesi bu süreden eskiyse çevrimdışı kapı açma reddedilir.";
